export default "__VITE_ASSET__p82qRd9W__"